// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer Styling */
/* Footer Styling */
.footer {

  background-color: #0d707e;
  color: white;
  padding: 20px 15px;
  width: 100%;
  margin: 0;
  background-color: #0f6679; /* Teal background */
  color: #6bb9c7;
  padding: 20px 10px;
  font-family: Arial, sans-serif;
  text-align: center;
  margin-top: 5px;
 
}

.footer-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1000px;
  height:85px;
  margin: 0 auto;
  flex-wrap: wrap;
  
  flex-direction: row; /* Make sure elements are in a row on desktop */
}

/* QR Code Section */
.footer-logo {
  margin-top: 10px;
  text-align: center;
  margin-left: -120px;
}

.footer-logo img {
  max-width: 200px;  /* Make the QR code smaller */
  height: auto;
  
  margin-bottom: 5px;
}

/* Social Icons Section */
.social-icons {
  display: flex;
  gap: 25px;
  justify-content: center;
  margin-top: -20px;
  margin-left:-40px;
  
}

.social-icon {
  color: #fff;
  text-decoration: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 50px;  /* Circle width */
  height: 50px; /* Circle height */
  border: 2.5px solid #fff;  /* Thin white border */
  border-radius: 50%;  /* Makes the border circular */
  font-size: 12px;  /* Adjusted icon size */
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.social-icon:hover {
  color: #28a745;  /* Green color on hover */
  background-color: #fff; /* White background on hover */
  border-color: #28a745;  /* Green border on hover */
}
.floginbtn button {
  margin-right: -1500px;
  padding: 12px 60px; /* Adjust spacing around text */
  font-size: 1rem; /* Slightly larger text */
  font-weight: bold; /* Make the text bold */
  color: white; /* Text color */
  background-color: #28a745; /* Green background */
  border: none; /* Remove border */
  border-radius: 8px; /* Rounded corners */
  cursor: pointer; /* Pointer cursor on hover */
  transition: background-color 0.3s ease, transform 0.2s ease;
  margin-top:25px;
}

.floginbtn button:hover {
  background-color: #218838; /* Darker green on hover */
  transform: scale(1.05); /* Slight zoom-in effect */
}

.floginbtn button:active {
  background-color: #1e7e34; /* Even darker green when clicked */
  transform: scale(0.98); /* Slight shrink effect */
}

.floginbtn button:focus {
  outline: 2px solid #28a745; /* Green outline for accessibility */
  outline-offset: 4px; /* Space between outline and button */
}
floginbtn ul {
  list-style: none; /* Remove bullets from the list */
  margin: 0;
  padding: 0;
}

.floginbtn  p{
 font-size: large;
 color: white;
 font-weight: 700;
 margin:0;
 margin-right: -1500px;
 
}



/* Links Section */
.footer-links {
  display: flex;
  gap: 20px;
  margin-right:250px;
  flex-wrap: wrap;
  order: 1; /* This makes links come after the feedback section */
}

.footer-links a {
  margin-bottom: 40px;
  text-decoration: none;
  color: #fff;
  font-size: 1.1rem;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: #28a745; /* Green hover effect */
}

/* Feedback Section */
.footer-feedback {
  text-align: left;
  max-width: 300px;
  color: #fff;
  font-size: 0.9rem;
  order: 2; /* This places the feedback section before the links */
}

.footer-feedback p {
  margin: 5px 0;
  margin-left: 70px;
  font-size: 1.0rem;
}

.feedback-button {
  
  padding: 10px 30px;
  font-size: 0.7rem;
  color: black;
  background-color: #28a745; /* Green button */
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  z-index: 10;
  margin-left :20px;
}

.feedback-button:hover {
  background-color: #218838; /* Darker green on hover */
}

/* Copyright Section */
.footer-bottom {
  margin-top: 40px;
  font-size: 0.6rem;
  margin-left: -40px;
  color: #ccc;
}
.footer-slogan{
  display: none;
}
.social-icons2{
  display: none;
}
@media (max-width: 768px) {
  .hide-footer-mobile {
    display: none;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-container {
    flex-direction: column; /* Stack everything vertically */
    height: 100%;
    width:-40px;
    margin-left:20px;
  }

  .footer-links {
    display: none;
    gap: 5px;
  }

  .social-icons {
    
    margin-top:20px;
    margin-left:0px;
    gap: 10px;
    margin-bottom:20px;
  }
  .social-icon {
    color: #fff;
    text-decoration: none;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 60px;  /* Circle width */
    height: 60px; /* Circle height */
    border: 3.0px solid #fff;  /* Thin white border */
    border-radius: 50%;  /* Makes the border circular */
    font-size: 12px;  /* Adjusted icon size */
    transition: background-color 0.3s ease, border-color 0.3s ease;
  }
  .footer-logo img {
    max-width: 120px; /* Smaller logo for smaller screens */
    display: none;
  }

  
  .footer-bottom p {
    font-size: 0.8rem; 
    margin-right:-50px; 
  }

  .floginbtn button {
    width: 100%;
    padding: 10px;
    margin-right:0px;
  }

  .floginbtn p {
    width: 100%;
    font-size: 23px;
    margin-right:30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB,mBAAmB;AACnB;;EAEE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,yBAAyB,EAAE,oBAAoB;EAC/C,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;;AAEjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,eAAe;;EAEf,mBAAmB,EAAE,+CAA+C;AACtE;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB,GAAG,6BAA6B;EAChD,YAAY;;EAEZ,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;;AAEnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW,GAAG,iBAAiB;EAC/B,YAAY,EAAE,kBAAkB;EAChC,wBAAwB,GAAG,sBAAsB;EACjD,kBAAkB,GAAG,8BAA8B;EACnD,eAAe,GAAG,uBAAuB;EACzC,8DAA8D;AAChE;;AAEA;EACE,cAAc,GAAG,yBAAyB;EAC1C,sBAAsB,EAAE,8BAA8B;EACtD,qBAAqB,GAAG,0BAA0B;AACpD;AACA;EACE,qBAAqB;EACrB,kBAAkB,EAAE,+BAA+B;EACnD,eAAe,EAAE,yBAAyB;EAC1C,iBAAiB,EAAE,uBAAuB;EAC1C,YAAY,EAAE,eAAe;EAC7B,yBAAyB,EAAE,qBAAqB;EAChD,YAAY,EAAE,kBAAkB;EAChC,kBAAkB,EAAE,oBAAoB;EACxC,eAAe,EAAE,4BAA4B;EAC7C,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,sBAAsB,EAAE,0BAA0B;AACpD;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,sBAAsB,EAAE,yBAAyB;AACnD;;AAEA;EACE,0BAA0B,EAAE,oCAAoC;EAChE,mBAAmB,EAAE,qCAAqC;AAC5D;AACA;EACE,gBAAgB,EAAE,iCAAiC;EACnD,SAAS;EACT,UAAU;AACZ;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,gBAAgB;CAChB,QAAQ;CACR,qBAAqB;;AAEtB;;;;AAIA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,QAAQ,EAAE,qDAAqD;AACjE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,uBAAuB;AACzC;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,QAAQ,EAAE,sDAAsD;AAClE;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB,EAAE,iBAAiB;EAC5C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB,EAAE,gCAAgC;IACxD,YAAY;IACZ,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;;IAEE,eAAe;IACf,eAAe;IACf,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW,GAAG,iBAAiB;IAC/B,YAAY,EAAE,kBAAkB;IAChC,wBAAwB,GAAG,sBAAsB;IACjD,kBAAkB,GAAG,8BAA8B;IACnD,eAAe,GAAG,uBAAuB;IACzC,8DAA8D;EAChE;EACA;IACE,gBAAgB,EAAE,qCAAqC;IACvD,aAAa;EACf;;;EAGA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/* Footer Styling */\n/* Footer Styling */\n.footer {\n\n  background-color: #0d707e;\n  color: white;\n  padding: 20px 15px;\n  width: 100%;\n  margin: 0;\n  background-color: #0f6679; /* Teal background */\n  color: #6bb9c7;\n  padding: 20px 10px;\n  font-family: Arial, sans-serif;\n  text-align: center;\n  margin-top: 5px;\n \n}\n\n.footer-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1000px;\n  height:85px;\n  margin: 0 auto;\n  flex-wrap: wrap;\n  \n  flex-direction: row; /* Make sure elements are in a row on desktop */\n}\n\n/* QR Code Section */\n.footer-logo {\n  margin-top: 10px;\n  text-align: center;\n  margin-left: -120px;\n}\n\n.footer-logo img {\n  max-width: 200px;  /* Make the QR code smaller */\n  height: auto;\n  \n  margin-bottom: 5px;\n}\n\n/* Social Icons Section */\n.social-icons {\n  display: flex;\n  gap: 25px;\n  justify-content: center;\n  margin-top: -20px;\n  margin-left:-40px;\n  \n}\n\n.social-icon {\n  color: #fff;\n  text-decoration: none;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 50px;  /* Circle width */\n  height: 50px; /* Circle height */\n  border: 2.5px solid #fff;  /* Thin white border */\n  border-radius: 50%;  /* Makes the border circular */\n  font-size: 12px;  /* Adjusted icon size */\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n.social-icon:hover {\n  color: #28a745;  /* Green color on hover */\n  background-color: #fff; /* White background on hover */\n  border-color: #28a745;  /* Green border on hover */\n}\n.floginbtn button {\n  margin-right: -1500px;\n  padding: 12px 60px; /* Adjust spacing around text */\n  font-size: 1rem; /* Slightly larger text */\n  font-weight: bold; /* Make the text bold */\n  color: white; /* Text color */\n  background-color: #28a745; /* Green background */\n  border: none; /* Remove border */\n  border-radius: 8px; /* Rounded corners */\n  cursor: pointer; /* Pointer cursor on hover */\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  margin-top:25px;\n}\n\n.floginbtn button:hover {\n  background-color: #218838; /* Darker green on hover */\n  transform: scale(1.05); /* Slight zoom-in effect */\n}\n\n.floginbtn button:active {\n  background-color: #1e7e34; /* Even darker green when clicked */\n  transform: scale(0.98); /* Slight shrink effect */\n}\n\n.floginbtn button:focus {\n  outline: 2px solid #28a745; /* Green outline for accessibility */\n  outline-offset: 4px; /* Space between outline and button */\n}\nfloginbtn ul {\n  list-style: none; /* Remove bullets from the list */\n  margin: 0;\n  padding: 0;\n}\n\n.floginbtn  p{\n font-size: large;\n color: white;\n font-weight: 700;\n margin:0;\n margin-right: -1500px;\n \n}\n\n\n\n/* Links Section */\n.footer-links {\n  display: flex;\n  gap: 20px;\n  margin-right:250px;\n  flex-wrap: wrap;\n  order: 1; /* This makes links come after the feedback section */\n}\n\n.footer-links a {\n  margin-bottom: 40px;\n  text-decoration: none;\n  color: #fff;\n  font-size: 1.1rem;\n  transition: color 0.3s ease;\n}\n\n.footer-links a:hover {\n  color: #28a745; /* Green hover effect */\n}\n\n/* Feedback Section */\n.footer-feedback {\n  text-align: left;\n  max-width: 300px;\n  color: #fff;\n  font-size: 0.9rem;\n  order: 2; /* This places the feedback section before the links */\n}\n\n.footer-feedback p {\n  margin: 5px 0;\n  margin-left: 70px;\n  font-size: 1.0rem;\n}\n\n.feedback-button {\n  \n  padding: 10px 30px;\n  font-size: 0.7rem;\n  color: black;\n  background-color: #28a745; /* Green button */\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  z-index: 10;\n  margin-left :20px;\n}\n\n.feedback-button:hover {\n  background-color: #218838; /* Darker green on hover */\n}\n\n/* Copyright Section */\n.footer-bottom {\n  margin-top: 40px;\n  font-size: 0.6rem;\n  margin-left: -40px;\n  color: #ccc;\n}\n.footer-slogan{\n  display: none;\n}\n.social-icons2{\n  display: none;\n}\n@media (max-width: 768px) {\n  .hide-footer-mobile {\n    display: none;\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .footer-container {\n    flex-direction: column; /* Stack everything vertically */\n    height: 100%;\n    width:-40px;\n    margin-left:20px;\n  }\n\n  .footer-links {\n    display: none;\n    gap: 5px;\n  }\n\n  .social-icons {\n    \n    margin-top:20px;\n    margin-left:0px;\n    gap: 10px;\n    margin-bottom:20px;\n  }\n  .social-icon {\n    color: #fff;\n    text-decoration: none;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: 60px;  /* Circle width */\n    height: 60px; /* Circle height */\n    border: 3.0px solid #fff;  /* Thin white border */\n    border-radius: 50%;  /* Makes the border circular */\n    font-size: 12px;  /* Adjusted icon size */\n    transition: background-color 0.3s ease, border-color 0.3s ease;\n  }\n  .footer-logo img {\n    max-width: 120px; /* Smaller logo for smaller screens */\n    display: none;\n  }\n\n  \n  .footer-bottom p {\n    font-size: 0.8rem; \n    margin-right:-50px; \n  }\n\n  .floginbtn button {\n    width: 100%;\n    padding: 10px;\n    margin-right:0px;\n  }\n\n  .floginbtn p {\n    width: 100%;\n    font-size: 23px;\n    margin-right:30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
